import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Button, Input, Group, Text, Select, Table, Pagination, Skeleton } from '@mantine/core';
import { IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import CampaignReport from "../../api/CampaignReport";
import TestsApi from "../../api/TestsApi";
import { VisiLoader, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export function CustomerJourney({ emailValue, setEmailValue, reportTimeValue, campaignId, campaignGoalId, customerJourneyType, isCustomerJourneyModalOpen, onCustomerJourneyClose,customerJourneyCampaignDataId,report_id,customerJourneyAdsNetwork,customerJourneyAdsNetworkType,customerJourneyAdsNetworkName, customerJourneyPayloadData,customerJourneyGoalType, goalTestId, customerJourneyCampaignName, customerJourneyAdsetName, testJourneyPayload = null}:any) {
  const navigate = useNavigate();

  // Test Report has its own endpoint; both share the response shape so the rest of this drawer is identical
  const getCustomerJourneyList = (dataObject:any) => {
    if (testJourneyPayload) {
      return TestsApi.gettestcustomerjourneylist({
        ...testJourneyPayload,
        page: dataObject.page,
        sort_dir: dataObject.sort_dir,
        customer_email: dataObject.customer_email ? dataObject.customer_email : ''
      });
    }
    return CampaignReport.getcustomerjourneylist(dataObject);
  };

  const [campaignName, setCampaignName] = useState('');
  const [customerJourneyData, setCustomerJourneyData] = useState([]);
  const [activePageNo, setActivePageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(10);
  const [totalPaginationNo, setTotalPaginationNo] = useState(1);

  const [isCustomerJourneyViewModalOpen, setIsCustomerJourneyViewModalOpen] = useState(false);
  const [journeyViewData, setJourneyViewData] = useState([]);
  const [journeyType, setJourneyType] = useState('');

  const [campaignDropDisplay, setCampaignDropDisplay] = useState('');
  const [campaignDropList, setCampaignDropList] = useState([]);
  const [dropListvalue, setDropListvalue] = useState('');
  const [customerJourneyLoader, setCustomerJourneyLoader] = useState(false);
  /* The drawer is paged in SQL, so the date sort has to be resolved by the API - sorting the
     10 rows already on screen would only reorder the current page. */
  const [sortDir, setSortDir] = useState('desc');
  const [customerJourneyMessage, setCustomerJourneyMessage] = useState('');
  const [customerJourneyPayload, setCustomerJourneyPayload] = useState<number | string | object | any[]>(null);

  const [goalCampaignId, setGoalCampaignId] = useState(null);
  const [trafficSourceCampaignId, setTrafficSourceCampaignId] = useState(null);

  const [goalType, setGoalType] = useState(null);
  const [testVariationtestId, setTestVariationtestId] = useState(null);

  useEffect(() => {
    if(isCustomerJourneyModalOpen){
      setCustomerJourneyPayload(customerJourneyPayloadData);
      setGoalType(customerJourneyGoalType);
      setTestVariationtestId(goalTestId);
      CustomerJourneyList('',activePageNo,customerJourneyType,campaignGoalId,customerJourneyPayloadData,customerJourneyGoalType, goalTestId);
      setJourneyType(customerJourneyType);
    }
    if (!isCustomerJourneyModalOpen) {
      setActivePageNo(1);
      setSortDir('desc');
    }
  }, [isCustomerJourneyModalOpen, customerJourneyType]);

  const CustomerJourneyList = (value:any,activePageNo:any,type:any='',goal_id:any,customerPayload,selectedGoalType:any,test_id:any,sort_dir:any=null) => {
    const dataObject = {
      campaign_goal: goal_id,
      page: activePageNo,
      sort_dir: sort_dir ? sort_dir : sortDir,
      time_value: reportTimeValue,
      report_id: report_id,
      ads_network: customerJourneyAdsNetwork,
      ads_network_type: customerJourneyAdsNetworkType,
      ads_network_name: customerJourneyAdsNetworkName,
      journey_type: type,
      campaign_goal_type: selectedGoalType,
      test_id: test_id,
    } as any;
    if (customerJourneyType === 'traffic_source') {
      dataObject.campaign_id = customerJourneyCampaignDataId;
    } else {
      dataObject.campaign_id = campaignId;
    }
    if(customerJourneyType === 'source'){
      dataObject.source_id = customerPayload;
    }
    if(customerJourneyType === 'tracking_tag'){
      dataObject.tracking_tag_data = customerPayload;
    }
    if(customerJourneyType === 'custom_tag'){
      dataObject.custom_tag_data = customerPayload;
    }
    if(customerJourneyAdsNetworkType === 'adset'){
      dataObject.campaign_name = customerJourneyCampaignName;
    }
    if(customerJourneyAdsNetworkType === 'ad'){
      dataObject.campaign_name = customerJourneyCampaignName;
      dataObject.adset_name = customerJourneyAdsetName;
    }
    setGoalCampaignId(campaignId);
    setTrafficSourceCampaignId(customerJourneyCampaignDataId);
    // Clear the previous journey so the loader never sits over stale rows
    setCustomerJourneyData([]);
    setCustomerJourneyMessage('');
    setCustomerJourneyLoader(true);
    getCustomerJourneyList(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setCustomerJourneyLoader(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setCampaignName(data.data.campaign_name);
        setCustomerJourneyData(data.data.customer_journey_data);
        if (data.data.active_page_no !== activePageNo) {
          setActivePageNo(data.data.active_page_no);
          setActivePageNo(1);
        }
        if (data.data.total_pages !== totalPages) {
          setTotalPages(data.data.total_pages);
        }
        if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
          setTotalPaginationNo(data.data.total_pagination_no);
        }
        setCampaignDropDisplay(data.data.campaign_drop_display);
        setCampaignDropList(data.data.campaign_drop_list);
        setCustomerJourneyLoader(false);
      }else{
        // Failed / no journey for this conversion — clear rows and surface the message
        setCustomerJourneyData([]);
        setTotalPages(1);
        setCustomerJourneyMessage((data && data.message) ? data.message : 'No data found');
        setCustomerJourneyLoader(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setCustomerJourneyData([]);
      setCustomerJourneyMessage('Something went wrong. Please try again.');
      setCustomerJourneyLoader(false);
    });
  };

  const dropListData = [
    { value: '', label: 'Select Campaign', disabled: true },
    ...campaignDropList.map((dropListData) => ({
      value: dropListData.campaign_id,
      label: dropListData.campaign_name
    })),
  ];

  useEffect(() => {
    const selectedCampaign = campaignDropList.find((dropListData) => dropListData.selected === "selected");
    if (selectedCampaign) {
      setDropListvalue(selectedCampaign.campaign_id);
    }
  }, [campaignDropList]);

  const handleCustomerJourneyFilter = (e) => {
    e.preventDefault();
    runEmailFilter(sortDir);
  };

  const runEmailFilter = (sort_dir:any) => {
    setCustomerJourneyData([]);

    const dataObject = {
      selected_campaign_id: dropListvalue,
      campaign_goal: campaignGoalId,
      customer_email: emailValue,
      page: activePageNo,
      sort_dir: sort_dir ? sort_dir : sortDir,
      time_value: reportTimeValue,
      report_id: report_id,
      ads_network: customerJourneyAdsNetwork,
      ads_network_type: customerJourneyAdsNetworkType,
      ads_network_name: customerJourneyAdsNetworkName,
      journey_type: customerJourneyType,
      campaign_goal_type: goalType,
      test_id: testVariationtestId,
    } as any;

    if (customerJourneyType === 'traffic_source') {
      dataObject.campaign_id = trafficSourceCampaignId;
    } else {
      dataObject.campaign_id = goalCampaignId;
    }
    if(customerJourneyType === 'source'){
      dataObject.source_id = customerJourneyPayload;
    }
    if(customerJourneyType === 'tracking_tag'){
      dataObject.tracking_tag_data = customerJourneyPayload;
    }
    if(customerJourneyType === 'custom_tag'){
      dataObject.custom_tag_data = customerJourneyPayload;
    }
    if(customerJourneyAdsNetworkType === 'adset'){
      dataObject.campaign_name = customerJourneyCampaignName;
    }
    if(customerJourneyAdsNetworkType === 'ad'){
      dataObject.campaign_name = customerJourneyCampaignName;
      dataObject.adset_name = customerJourneyAdsetName;
    }
    setCustomerJourneyLoader(true);
    getCustomerJourneyList(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setCustomerJourneyLoader(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setCampaignName(data.data.campaign_name);
        setCustomerJourneyData(data.data.customer_journey_data);
        if (data.data.active_page_no !== activePageNo) {
          setActivePageNo(data.data.active_page_no);
          setActivePageNo(1);
        }
        if (data.data.total_pages !== totalPages) {
          setTotalPages(data.data.total_pages);
        }
        if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
          setTotalPaginationNo(data.data.total_pagination_no);
        }
        setCustomerJourneyLoader(false);
      }else{
        setCustomerJourneyLoader(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setCustomerJourneyLoader(false);
    });
  };

  const handleCustomerJourneyView = (visitorsession:any) => {
    setIsCustomerJourneyViewModalOpen(true);
    setCustomerJourneyLoader(true);
    CampaignReport.getcustomerjourneyviewdetail({
      visitor_session_id: visitorsession
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setCustomerJourneyLoader(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setJourneyViewData(data.data.journey_data);
        setCustomerJourneyLoader(false);
      }else{
        setCustomerJourneyLoader(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setCustomerJourneyLoader(false);
    });
  };

  const handleCustomerJourneyViewCloseModal = () => {
    setIsCustomerJourneyViewModalOpen(false);
  };

  const handlePageChange = (newPage) => {
    CustomerJourneyList('',newPage,journeyType,campaignGoalId,customerJourneyPayload,goalType,testVariationtestId,sortDir);
    setActivePageNo(newPage);
  };

  /* Sorting restarts at page 1 and keeps whatever email filter is currently applied. */
  const handleDateSort = () => {
    const nextSortDir = (sortDir === 'desc') ? 'asc' : 'desc';
    setSortDir(nextSortDir);
    setActivePageNo(1);
    if (emailValue !== '') {
      runEmailFilter(nextSortDir);
    } else {
      CustomerJourneyList('',1,journeyType,campaignGoalId,customerJourneyPayload,goalType,testVariationtestId,nextSortDir);
    }
  };

  const listRows = customerJourneyData.length > 0 ? (
    customerJourneyData.map((item, index) => (
      <tr key={index}>
        <td><Text>{item.date}</Text></td>
        <td><Text>{item.sales_amount}</Text></td>
        <td><Text>{item.subscription_amount}</Text></td>
        <td style={{wordWrap: 'break-word', maxWidth: '150px'}}><Text>{item.email}</Text></td>
        <td style={{ color: 'green', cursor: 'pointer' }} onClick={() => handleCustomerJourneyView(item.visitor_session)}><Text>{"View"}</Text></td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}><Text>{customerJourneyMessage || 'No data found'}</Text></td>
    </tr>
  );

  const JourneyViewList = journeyViewData.length > 0 ? (
    journeyViewData.map((item, index) => (
      <tr key={index}>
        <td><Text>{item.date}</Text></td>
        <td style={{wordWrap: 'break-word', maxWidth: '120px'}}>
          {item.page_details.page_url !== '' && (<Text>{item.page_details.page_url}</Text>)}
          {item.page_details.page_title !== '' && (<Text>{"Page Title : "}{item.page_details.page_title}</Text>)}
          {item.page_details.postback_title !== '' && (<Text>{"Postback Name : "}{item.page_details.postback_title}</Text>)}
          {item.page_details.webhook_title !== '' && (<Text>{"Webhook Name : "}{item.page_details.webhook_title}</Text>)}
        </td>
        <td style={{wordWrap: 'break-word', maxWidth: '120px'}}><Text>{item.customer_email}</Text></td>
        <td><Text>{item.traffic_source}</Text></td>
        <td><Text>{item.sales_amount}</Text></td>
        {item.attribution ? (
          <td><Text>{"Attribution : "}{item.attribution}</Text></td>
        ) : (
          <td></td>
        )}
        <td style={{wordWrap: 'break-word', maxWidth: '150px'}}>
            {item.behavioral_details.ads_network_type ? (
              <Text>{"Ads Network type : "}{item.behavioral_details.ads_network_type}</Text>
            ) : (
              <Text></Text>
            )}
            {item.behavioral_details.network_tag &&
              Object.entries(item.behavioral_details.network_tag).map(([key, value]) => (
                <Text key={key}>{`${key} : ${value}`}</Text>
              ))
            }
            {item.behavioral_details.custom_tag &&
              Object.entries(item.behavioral_details.custom_tag).map(([key, value]) => (
                <Text key={key}>{`${key} : ${value}`}</Text>
              ))
            }
            {item.behavioral_details.source_tag &&
              Object.entries(item.behavioral_details.source_tag).map(([key, value]) => (
                <Text key={key}>{`${key} : ${value}`}</Text>
              ))
            }
        </td>
        {item.device ? (
          <td><Text>{"Device : "}{item.device}</Text></td>
        ) : (
          <td></td>
        )}
        <td><Text>{item.referral_source}</Text></td>
        <td><Text>{item.v_no}</Text></td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={10} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );


  const handleCampaignDropChange = (value:any) => {
    setDropListvalue(value);
  };

  return (
    <>
      <Modal.Root opened={isCustomerJourneyModalOpen} onClose={onCustomerJourneyClose} size="80%" trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={customerJourneyLoader} />
          <Modal.Header>
            <Modal.Title>
              {"Customer Journey - "}
              {campaignName
                ? campaignName
                : <Skeleton height={14} width={100} style={{display:'inline-block', verticalAlign:'middle'}} />}
              {' '}
              <HelpTip helpId={317} />
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body h={500}>
            <form onSubmit={handleCustomerJourneyFilter}>
              <Group mb="xs">
                {campaignDropDisplay !== "hide" && (
                  <>
                  <Text>Select Campaign:</Text>
                  <Select
                    dropdownPosition="bottom"
                    value={dropListvalue}
                    searchable
                    data={dropListData}
                    onChange={handleCampaignDropChange}
                  />
                  </>
                )}
              </Group>
              <Group mb="xs">  
                <Text mt={4} mr={10}>Email: </Text>              
                <Input value={emailValue} onChange={(e) => setEmailValue(e.target.value)} />
                <Button type="submit" size="sm" w={80}>
                  Filter
                </Button>
              </Group>
            </form>
            <SimpleBar autoHide={false} style={{ maxHeight: 380,paddingRight: '15px'}}>
            <Table striped highlightOnHover withBorder my={5} fontSize="xs" key={"goalIndex"}>
              <thead>
                <tr>
                  <th
                    onClick={handleDateSort}
                    style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    title={sortDir === 'desc' ? 'Sorted newest first - click for oldest first' : 'Sorted oldest first - click for newest first'}
                  >
                    {"Date "}
                    {sortDir === 'desc'
                      ? <IconChevronDown size="0.8rem" style={{ marginBottom: -2 }} />
                      : <IconChevronUp size="0.8rem" style={{ marginBottom: -2 }} />}
                  </th>
                  <th>Sales Amount</th>
                  <th>Subscription Amount</th>
                  <th>Email</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>{listRows}</tbody>
            </Table>
            </SimpleBar>
            {totalPages > 1 ? (
              <div style={{ marginTop: '12px', paddingBottom: '20px' }}>
              <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange}>
                <Group spacing={5} position="center">
                  <Pagination.First />
                  <Pagination.Previous />
                  <Pagination.Items />
                  <Pagination.Next />
                  <Pagination.Last />
                </Group>
              </Pagination.Root>
              </div>
            ) : ''} 
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      <Modal.Root opened={isCustomerJourneyViewModalOpen} onClose={handleCustomerJourneyViewCloseModal} size="80%" trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={customerJourneyLoader} />
          <Modal.Header>
            <Modal.Title>{"Customer Journey - "}{campaignName} <HelpTip helpId={317} /></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body h={500}>
            <Group mb="xs" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text mt={4}>Customer Journey Report</Text>
              <Button type="submit" size="sm" w={80} onClick={handleCustomerJourneyViewCloseModal}>
                Back
              </Button>
            </Group>

          <SimpleBar autoHide={false} style={{paddingBottom: '12px',paddingRight: '15px', maxHeight: '410px' }}>
            <Table striped highlightOnHover withBorder my={5} fontSize="xs" key={"goalIndex"} withColumnBorders>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Page Details</th>
                  <th>Customer Email</th>
                  <th>Traffic Source</th>
                  <th>Sales Amount</th>
                  <th>Attribution</th>
                  <th>Behavioral Details</th>
                  <th>Device</th>
                  <th>Referral Source</th>
                  <th>V.No.</th>
                </tr>
              </thead>
              <tbody>{JourneyViewList}</tbody>
            </Table>
            </SimpleBar>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}